import { Box, Stack, Typography } from "@mui/material";
import { useTBContext } from "../../Contexts/useTBStates";

interface MatchBoxProps {
    matchOrder: any;
    matchReg: any;
   /*  matchScores: any; */
    regionIndex: number;
    index: number;
    indexCol: number;
    /* factor: number; */
    regionRounds: number;
    baseWidth: number;
    baseHeight: number;
    spaceHeight: number;
    side: string;
}

export const MatchBox = ({matchOrder, matchReg, /* matchScores, */ regionIndex, index, indexCol, /* factor, */ regionRounds, baseWidth, baseHeight, spaceHeight, side}: MatchBoxProps) => {
    
    const {appTheme, factor} = useTBContext();

    /* console.log(index,matchOrder);
    console.log(matchReg); */
    const midIndex = Math.pow(2,index)/2;
    const boxHeight = (
        (regionRounds - index - 1) === 0 ? baseHeight :
        (baseHeight + spaceHeight) * Math.pow(2, regionRounds - index - 2)
    );

    const matchNames = {
        player1: matchReg?.filter((reg: any) => reg.matchRank === matchOrder.player1)[0]?.playerName ||
             (matchOrder.player1 === 'BYE' ? 'BYE' : `Player ${matchOrder.player1}`),
        player2: matchReg?.filter((reg: any) => reg.matchRank === matchOrder.player2)[0]?.playerName ||
             (matchOrder.player2 === 'BYE' ? 'BYE' : `Player ${matchOrder.player2}`),
    }
    
    return (
        <Stack key={`${side}-${regionIndex}-${index}-${indexCol}`} direction='column' flex={1} justifyContent='center'>
            <Stack direction={side === 'left' ? 'row' : 'row-reverse'} spacing={0.75} marginLeft={side === 'left' ? 0.5 : 0} marginRight={side === 'right' ? 0.5 : 0} 
                justifyContent={'flex-start'}
                >
                <Typography sx={{height: 15*factor, fontSize: 12*factor}}>
                    {indexCol < midIndex ?
                        (index === regionRounds - 1 ?
                        (matchNames.player1 === 'BYE' ? '' : matchOrder.player1) : (`   `)) :
                        (index === regionRounds - 1 ?
                            (matchNames.player2 === 'BYE' ? '' : matchOrder.player2) : (`   `))
                    }
                </Typography>
                <Typography sx={{height: 15*factor, fontSize: 12*factor, fontStyle: 'italic'}}>
                    {indexCol < midIndex ?
                        (index === regionRounds - 1 ?
                        (matchNames.player1) :
                        (`   `)) :
                        (index === regionRounds - 1 ?
                            (matchNames.player2) :
                            (`   `))
                    }
                </Typography>
            </Stack>
            <Stack 
                direction='column' 
                height={boxHeight}
                width={baseWidth}
                justifyContent={side === 'left' ? 'flex-start' : side === 'right' ? 'flex-end' : 'center'}
                borderTop={`1px solid ${appTheme.palette.primary.main}`} 
                borderBottom={`1px solid ${appTheme.palette.primary.main}`} 
                borderRight={side === 'left' ? `1px solid ${appTheme.palette.primary.main}` : 'none'}
                borderLeft={side === 'right' ? `1px solid ${appTheme.palette.primary.main}` : 'none'}
            >
                <Typography sx={{ height: 15*factor, fontSize: 12*factor}}>   </Typography>
                <Stack direction='column' display='flex' height={'100%'} justifyContent='center' alignItems='center'>
                    <Typography sx={{ fontSize: 12*factor }}>
                        {index === regionRounds - 1 ? 'Time or Score' : (`   `)}
                    </Typography>
                </Stack>
                <Stack direction={side === 'left' ? 'row' : 'row-reverse'} spacing={0.75} marginLeft={side === 'left' ? 0.5 : 0} marginRight={side === 'right' ? 0.5 : 0} 
                    justifyContent={'flex-start'}>
                    <Typography sx={{height: 15*factor, fontSize: 12*factor}}>
                        {indexCol < midIndex ?
                            (index === regionRounds - 1 ?
                            (matchNames.player2 === 'BYE' ? '' : matchOrder.player2) :
                            (`   `)) :
                            (index === regionRounds - 1 ?
                                (matchNames.player1 === 'BYE' ? '' : matchOrder.player1) :
                                (`   `))
                        }
                    </Typography>
                    <Typography sx={{height: 15*factor, fontSize: 12*factor, fontStyle: 'italic'}}>
                        {indexCol < midIndex ?
                            (index === regionRounds - 1 ?
                            (matchNames.player2) :
                            (`   `)) :
                            (index === regionRounds - 1 ?
                                (matchNames.player1) :
                                (`   `))
                        }
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    )
}
